import {normalizeDesign, hasCompleteSizing} from './design-model.js';

const owner = user => user ? `account:${String(user.id ?? user.email)}` : 'guest';
export const sizeProfileKey = user => `minimural-size-profile:${owner(user)}`;
export const addressBookKey = user => user ? `minimural-address-book:${String(user.id ?? user.email)}` : null;
const read = (storage, key, fallback) => { try { return key ? JSON.parse(storage.getItem(key)) ?? fallback : fallback; } catch { return fallback; } };

// Preferences contain sizing only. They never replace artwork or order snapshots.
export function sizingPatch(value) {
  if (!value || !['preset', 'per-finger', 'millimeter', 'tip-number'].includes(value.sizeMode)) return null;
  const validSize = size => ['XS','S','M','L'].includes(size);
  const complete = (values, valid) => Array.isArray(values) && values.length === 10 && values.every(valid);
  if (value.sizeMode === 'preset' ? !validSize(value.size) : value.size !== 'custom') return null;
  if (value.sizeMode === 'per-finger' && !complete(value.fingerSizes, validSize)) return null;
  if (value.sizeMode === 'tip-number' && !complete(value.tipNumbers, n => Number.isInteger(n) && n >= 0 && n <= 9)) return null;
  if (value.sizeMode === 'millimeter' && !complete(value.widths, n => Number.isFinite(n) && n >= 6 && n <= 25)) return null;
  const d = normalizeDesign(value);
  if (!hasCompleteSizing(d)) return null;
  return {size: d.size, sizeMode: d.sizeMode, fingerSizes: [...d.fingerSizes], widths: [...d.widths], tipNumbers: [...d.tipNumbers]};
}
export function readSizeProfile(user, storage = localStorage) {
  const record = read(storage, sizeProfileKey(user), null), sizing = sizingPatch(record?.sizing);
  return sizing ? {...record, sizing} : null;
}
export function saveSizeProfile(user, design, storage = localStorage) {
  const sizing = sizingPatch(design);
  if (!sizing) throw new Error('请补齐左右手十指尺寸');
  const record = {version: 1, sizing, shape: design.shape, updatedAt: new Date().toISOString()};
  storage.setItem(sizeProfileKey(user), JSON.stringify(record));
  return record;
}
export function forgetSizeProfile(user, storage = localStorage) { storage.removeItem(sizeProfileKey(user)); }
export function withSavedSizes(design, profile) {
  const sizing = sizingPatch(profile?.sizing);
  return sizing ? {...design, ...sizing} : design;
}

export const ADDRESS_FIELDS = ['name', 'phone', 'country', 'province', 'city', 'address', 'postalCode'];
export const SHIPPING_COUNTRIES = [['US','美国'],['GB','英国'],['CA','加拿大'],['FR','法国'],['DE','德国'],['ES','西班牙'],['IT','意大利'],['NL','荷兰'],['AU','澳大利亚'],['SG','新加坡'],['CN','中国大陆'],['HK','中国香港'],['MO','中国澳门'],['TW','中国台湾']];
export function readAddressBook(user, storage = localStorage) {
  const saved = read(storage, addressBookKey(user), []);
  return Array.isArray(saved) ? saved.filter(item => item && typeof item === 'object' && typeof item.id === 'string').slice(0,50) : [];
}
export function saveAddressBook(user, addresses, storage = localStorage) {
  const key = addressBookKey(user);
  if (!key) throw new Error('请先登录账户');
  storage.setItem(key, JSON.stringify(addresses));
}
export function addressToDraft(draft, address) {
  return {...draft, ...Object.fromEntries(ADDRESS_FIELDS.map(key => [key, String(address[key] ?? '')]))};
}
